import { render, staticRenderFns } from "./EmojiManager.vue?vue&type=template&id=5edd829a&scoped=true"
import script from "./EmojiManager.vue?vue&type=script&lang=js"
export * from "./EmojiManager.vue?vue&type=script&lang=js"
import style0 from "./EmojiManager.vue?vue&type=style&index=0&id=5edd829a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edd829a",
  null
  
)

export default component.exports